// extracted by mini-css-extract-plugin
module.exports = {"links":"style__links__u66zU"};